"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const mxp_schemas_1 = require("mxp-schemas");
const crypto_1 = require("crypto");
const user_1 = require("../user");
exports.startCase = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
exports.formatPrice = (amount, currency = 'USD') => {
    // IE fix for -($1010) below zero values wrapped in brackets
    const isLowerThan0 = amount < 0;
    const absAmount = Math.abs(amount);
    const minusPrefix = isLowerThan0 ? '-' : '';
    const formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(absAmount);
    return `${minusPrefix}${formatted}`;
};
exports.fromCentsFormat = (n) => n / 100;
exports.toCentsFormat = (n) => n * 100;
exports.formatPriceToTwoDecimalPoints = (price, currency = 'USD') => {
    return price % 1 === 0
        ? `${new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency || 'USD',
            minimumFractionDigits: 0,
        }).format(price)}`
        : exports.formatPrice(price, currency);
};
exports.centPriceToString = (price, currency = 'USD') => exports.formatPriceToTwoDecimalPoints(price / 100, currency).replace('.00', '');
exports.getCurrencySign = (currency = 'USD') => {
    var _a;
    return ((_a = new Intl.NumberFormat('en-US', { style: 'currency', currency }).formatToParts(1).find(x => x.type === 'currency')) === null || _a === void 0 ? void 0 : _a.value) || '$';
};
exports.getNasbaFieldOfStudy = (nasbaFieldOfStudy) => {
    return nasbaFieldOfStudy && nasbaFieldOfStudy.length ? nasbaFieldOfStudy.map((item) => item.label).sort() : null;
};
__export(require("./StringHelpers"));
__export(require("./ObjectsAndArraysHelpers"));
exports.getSafeLocale = (propName, obj, locale) => {
    return obj && obj[propName] && obj[propName][locale] ? obj[propName][locale] : '';
};
exports.cleanupOktaArrayClaim = (roles) => roles ? roles.filter(Boolean).map((role) => role.trim()) : [];
exports.generateRandomInt = () => {
    const min = 0;
    const max = 1000000;
    const range = max - min + 1;
    // Calculate the number of bytes needed to represent all the values within the range
    const bitsNeeded = Math.ceil(Math.log2(range));
    const bytesNeeded = Math.ceil(bitsNeeded / 8);
    // Calculate the maximum value that can be generated within the given number of bytes
    const maxValue = Math.pow(256, bytesNeeded);
    let randomValue;
    do {
        const generatedRandomBytes = crypto_1.randomBytes(bytesNeeded);
        randomValue = generatedRandomBytes.readUIntBE(0, bytesNeeded);
    } while (randomValue >= maxValue - (maxValue % range));
    return min + (randomValue % range);
};
exports.generateRandomPassword = (customerId, customerEmail) => {
    const rnd = crypto_1.randomBytes(16).toString('hex');
    return crypto_1.createHash('sha256').update(`${customerId}:${customerEmail}:${rnd}`).digest('hex');
};
__export(require("./omitProps"));
__export(require("./ParentProductHelpers"));
__export(require("./PriceHelpers"));
exports.arrayToMap = (array, keyField) => array.reduce((acc, element) => {
    acc[element[keyField]] = element;
    return acc;
}, {});
exports.replaceArrayPortion = (source, replaceFrom, equals) => source.reduce((acc, element) => acc.concat(replaceFrom.find(replaceWith => equals(element, replaceWith)) || element), []);
exports.unionWithSubstitution = (source, unionWith, equals) => {
    if (!source.length)
        return unionWith;
    if (!unionWith.length)
        return source;
    const leftUnion = exports.substitute(source, unionWith, equals);
    return unionWith.reduce((acc, element) => (acc.some(missing => equals(element, missing)) ? acc : acc.concat(element)), leftUnion);
};
exports.substitute = (source, replacement, equals) => source.reduce((acc, element) => acc.concat(replacement.find(replaceWith => equals(element, replaceWith)) || element), []);
// TODO - magic number will be move and for further checking
exports.canAvailCimaPqPremium = (accountingExperience, academiaExperience) => Number(accountingExperience) >= 6 || Number(academiaExperience) > 0;
const trimString = (value) => (value ? value.trim() : null);
exports.checkEmploymentFormRequiredFields = (requiredFieldsToCheck, employmentForm) => {
    if (employmentForm.organization) {
        return (requiredFieldsToCheck.filter((requiredFieldName) => {
            if (typeof requiredFieldName === 'object') {
                const [objectKeyName, objectValues] = Object.entries(requiredFieldName)[0];
                return (objectValues.filter((objectFieldName) => !trimString(employmentForm.organization[objectKeyName][objectFieldName])).length !== 0);
            }
            return !trimString(employmentForm.organization[requiredFieldName]);
        }).length === 0);
    }
    return false;
};
exports.findCommonElements = (array1, array2) => {
    return array1.some(item => array2.includes(item));
};
exports.transformLevelName = (string) => {
    const title = string.replace(/^\D+/g, '') === '1'
        ? user_1.LevelName.cert_ba
        : string.replace(/^\D+/g, '') === '2'
            ? user_1.LevelName.operational_OT
            : string.replace(/^\D+/g, '') === '3'
                ? user_1.LevelName.operational_CS
                : string.replace(/^\D+/g, '') === '4'
                    ? user_1.LevelName.management_OT
                    : string.replace(/^\D+/g, '') === '5'
                        ? user_1.LevelName.management_CS
                        : string.replace(/^\D+/g, '') === '6'
                            ? user_1.LevelName.strategic_OT
                            : string.replace(/^\D+/g, '') === '7'
                                ? user_1.LevelName.strategic_CS
                                : '';
    return title;
};
exports.flpTransformLevelName = (string) => {
    const title = string.replace(/^\D+/g, '') === '1'
        ? user_1.LevelNameFLP.Level_1
        : string.replace(/^\D+/g, '') === '2'
            ? user_1.LevelNameFLP.Level_2
            : string.replace(/^\D+/g, '') === '3'
                ? user_1.LevelNameFLP.Level_3
                : string.replace(/^\D+/g, '') === '4'
                    ? user_1.LevelNameFLP.Level_4
                    : string.replace(/^\D+/g, '') === '5'
                        ? user_1.LevelNameFLP.Level_5
                        : string.replace(/^\D+/g, '') === '6'
                            ? user_1.LevelNameFLP.Level_6
                            : string.replace(/^\D+/g, '') === '7'
                                ? user_1.LevelNameFLP.Level_7
                                : '';
    return title;
};
exports.chinesePQTransformLevelName = (string) => {
    const title = string.replace(/^\D+/g, '') === '6'
        ? user_1.LevelNameChinesePQ.Level_6
        : string.replace(/^\D+/g, '') === '7'
            ? user_1.LevelNameChinesePQ.Level_7
            : '';
    return title;
};
exports.getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
exports.flpTransformQualificationToNumber = (name) => {
    switch (name) {
        case mxp_schemas_1.ExemptionLevels.QualificationName.Cert:
        case mxp_schemas_1.ExemptionLevels.QualificationName.Business:
            return 1;
        case mxp_schemas_1.ExemptionLevels.QualificationName.Operational:
            return 2;
        case mxp_schemas_1.ExemptionLevels.QualificationName.Management:
            return 4;
        case mxp_schemas_1.ExemptionLevels.QualificationName.Strategic:
            return 6;
        default:
            return null;
    }
};
exports.getLevelNamebyNumber = (level, isFlp, isAicpaRegular, flpSwitchUpgrade) => {
    if (isFlp && Number(level) === mxp_schemas_1.ExemptionLevels.ExemptionLevels.Level_1) {
        return Number(level);
    }
    if (isFlp && Number(level) === mxp_schemas_1.ExemptionLevels.ExemptionLevels.Level_7 && isAicpaRegular) {
        return Number(level);
    }
    if (isFlp && flpSwitchUpgrade) {
        return Number(level);
    }
    if (isFlp && Number(level) % 2 !== 0) {
        return Number(level) - 1;
    }
    return Number(level);
};
//# sourceMappingURL=index.js.map